import { createContext, useState } from 'react';
import mainMessageBoxHandler from '../../helpers/ess-tgs-tes-mc/mainMessageBoxHandler';
import { useSelector } from 'react-redux';
import { selectUserInfo } from '../store/slices/userSlice';
import { selectFaults } from '../store/slices/FaultsSlice';

export const EssTgsTesContext = createContext();

const EssTgsTesProvider = ({ children }) => {
  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [openLocationMessageBox, setOpenLocationMessageBox] = useState(false);
  const [openSpecLocationMessageBox, setOpenSpecLocationMessageBox] =
    useState(false);
  const [message, setMessage] = useState([]);
  const [programName, setProgramName] = useState('');
  const [messageTitle, setMessageTitle] = useState('');

  const messageBoxHandler = (
    state,
    scope,
    type,
    programName,
  ) => {
    setProgramName(programName);
    const {
      openMessage,
      openLocationMessage,
      openSpecificLocationMessage,
      newMessage,
      newMessageTitle,
    } = mainMessageBoxHandler(
      state,
      scope,
      type,
      programName,
    
    );
    setMessage(newMessage);
    setMessageTitle(newMessageTitle);
    setOpenMessageBox(openMessage);
    setOpenLocationMessageBox(openLocationMessage);
    setOpenSpecLocationMessageBox(openSpecificLocationMessage);
  };

  return (
    <EssTgsTesContext.Provider
      value={{
        openMessageBox,
        setOpenMessageBox,
        openLocationMessageBox,
        setOpenLocationMessageBox,
        message,
        setMessage,
        programName,
        setProgramName,
        messageTitle,
        setMessageTitle,
        messageBoxHandler,
        openSpecLocationMessageBox,
        setOpenSpecLocationMessageBox,
      }}
    >
      {children}
    </EssTgsTesContext.Provider>
  );
};
export default EssTgsTesProvider;
